import { DocumentResponse, DocumentsResponse } from 'all-in-one-shared-api/dist/apis/documents/DocumentsResponse';

// import i18n from 'i18n';

export const getOthersDocuments = (documentsData: DocumentsResponse | undefined): DocumentResponse[] => {
  if (!documentsData) return [];

  let items: DocumentResponse[] = [];

  const { otherDocument } = documentsData;

  if (otherDocument && otherDocument.length > 0) {
    items = [...otherDocument];
  }

  return items;
};
